export interface IEntityAccountingCompany {
  id: string;
  name: string;
}
